import { gql } from 'urql';
import { PRODUCT } from '../client';

export const GET_ROUTING_IMPORT_PLAN_COMPARISON = gql`
  query ${PRODUCT}GetRoutingImportPlanComparison($input: RoutingImportPlanInput!) {
    routingImportPlan(input: $input) {
      id
      appliedRoutificRun {
        id
        label
        status
        truckCount
        createdAt
        routeCount
        totalStops
        totalDistanceMiles
        avgCubicUtilizationPercent
        estimatedDriverHours
        dprh
        unservedCount
        polylines
        vehicleStopIds
        routes {
          miles
          stops
          estimatedHours
          cubicUtilizationPercent
        }
      }
      # The latest dispatched run (newest finished etas_only) — what was actually
      # dispatched after any resequence / Calculate ETAs. DriverPath prefers this
      # over appliedRoutificRun, which LDS resolves by run-type priority and so
      # returns the original nightly run even after later runs change the layout.
      dispatchedRoutificRun {
        id
        status
        polylines
        vehicleStopIds
      }
      scenarios {
        id
        label
        status
        truckCount
        createdAt
        routeCount
        totalStops
        totalDistanceMiles
        avgCubicUtilizationPercent
        estimatedDriverHours
        dprh
        unservedCount
        polylines
        vehicleStopIds
        routes {
          miles
          stops
          estimatedHours
          cubicUtilizationPercent
        }
      }
      manualRoutificRuns {
        id
        label
        status
        truckCount
        createdAt
        routeCount
        totalStops
        totalDistanceMiles
        avgCubicUtilizationPercent
        estimatedDriverHours
        dprh
        unservedCount
        polylines
        vehicleStopIds
        routes {
          miles
          stops
          estimatedHours
          cubicUtilizationPercent
        }
      }
      actualRoutesSummary {
        routeCount
        totalStops
        totalDistanceMiles
        avgCubicUtilizationPercent
        driverHours
        dprh
        routes {
          miles
          stops
        }
      }
    }
  }
`;
